var render = function render(){var _vm=this,_c=_vm._self._c;return _c('path',{attrs:{"d":"M9,0a9,9,0,1,0,9,9A9,9,0,0,0,9,0ZM7.2,13.05V5L12.6,9Z"}})
}
var staticRenderFns = []

export { render, staticRenderFns }